import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'

const initInfo = async () => {
  const formStore = useFormStore()
  const result = apiHelperService.get(`/api/establishment/info`)
  if (!result) return
  result.then((res) => {
    const newDate = res?.licenseIssueDate.split('T')[0].split('-').reverse().join('/')
    if (Object.keys(res).length) {
      const {
        englishName,
        arabicName,
        number,
        department: { text: employerDepartment },
        sponsorType: { text: category }
      } = res
      formStore.form.setValues({
        employerEnglishName: englishName,
        employerArabicName: arabicName,
        employerDepartment,
        category,
        LicenseIssueDate: newDate,
        employerNumber: number
      })
    }
  })
}

export default async function () {
  try {
    await initInfo()
  } catch (error) {
    console.error('use920Preload error: ', error)
  }
}
